import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_PLAYER_SHOTS,
    FETCH_GOLF_PLAYER_SHOTS_FETCHING,
    FETCH_GOLF_PLAYER_SHOTS_SUCCESS,
    FETCH_GOLF_PLAYER_SHOTS_FAIL,
    UPDATE_GOLF_PLAYER_SHOTS,
    UPDATE_GOLF_PLAYER_SHOTS_UPDATING,
    UPDATE_GOLF_PLAYER_SHOTS_SUCCESS,
    UPDATE_GOLF_PLAYER_SHOTS_FAIL
} from 'actions/golfShotsActionTypes';

export function* fetchGolfPlayerShotsSaga(action) {
    try {
        yield put({
            type: FETCH_GOLF_PLAYER_SHOTS_FETCHING
        });

        const queryString = toQueryString({
            'image-size': 'IMG_730X730'
        });

        const url = `/gcs-golfcommunity/api/v2/shot/scorecard/${action.scorecardId}/hole${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_PLAYER_SHOTS_SUCCESS,
            playerShots: response.data,
            scorecardId: action.scorecardId
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_PLAYER_SHOTS_FAIL,
            playerShots: {},
            scorecardId: action.scorecardId,
            statusCode: e.response?.status,
            errorMessage: e.response?.data.errorMessage
        });
    }
}

export function* updateGolfPlayerShotsSaga(action) {
    try {
        yield put({
            type: UPDATE_GOLF_PLAYER_SHOTS_UPDATING
        });

        const url = `/gcs-golfcommunity/api/v2/shot/scorecard/${action.scorecardId}/hole/${action.holeNumber}`;

        const config = {
            headers: {
                'image-size': 'IMG_730X730',
                'json-response-body': true
            }
        };

        const response = yield call(golfApi.put, url, action.shots, config);
        // response is missing x,y coords. Since it was accepted, can assume our coord data is correct...
        // work around until GOLFAPP-19496 is completed
        const shots = response.data.map((shot, index) => {
            shot.startLoc = action.shots[index].startLoc;
            shot.endLoc = action.shots[index].endLoc;
            return shot;
        });

        yield put({
            type: UPDATE_GOLF_PLAYER_SHOTS_SUCCESS,
            shots: shots,
            scorecardId: action.scorecardId,
            holeNumber: action.holeNumber
        });
    } catch (e) {
        yield put({
            type: UPDATE_GOLF_PLAYER_SHOTS_FAIL,
            shots: {},
            scorecardId: action.scorecardId,
            errorMessage: e.response?.data.errorMessage,
            reasonCode: e.response?.data.reasonCode
        });
    }
}

export const golfPlayerShots = [
    takeEvery(FETCH_GOLF_PLAYER_SHOTS, fetchGolfPlayerShotsSaga),
    takeEvery(UPDATE_GOLF_PLAYER_SHOTS, updateGolfPlayerShotsSaga)
];
